// extracted by mini-css-extract-plugin
export var hideEditor = "_hv-2";
export var infoIcon = "_hv-3";
export var label = "_hv-1";
export var labelContainer = "_hv-0";
export var readonlyText = "_hv-4";